export const FLARES_OPTIONS = {
  events: [
    {
      key: 'iam',
      label: 'IAM',
    },
    {
      key: 'avc',
      label: 'AVC',
    },
    {
      key: 'tep',
      label: 'TEP',
    },
    {
      key: 'tvp',
      label: 'TVP',
    },
    {
      key: 'sepse',
      label: 'Sespe',
    },
    {
      key: 'ira',
      label: 'IRA',
    },
    {
      key: 'hepatite',
      label: 'Hepatite',
    },
    {
      key: 'meningite',
      label: 'Meningite',
    },
    {
      key: 'itu',
      label: 'ITU',
    },
    {
      key: 'erupcao_variceliforme',
      label: 'Erupção variceliforme',
    },
    {
      key: 'pielonefrite',
      label: 'Pielonefrite',
    },
  ],
  triggers: [
    {
      key: 'nao_identificado',
      label: 'Não Identificado',
    },
    {
      key: 'retirada_corticoide',
      label: 'Retirada de corticoide',
    },
    {
      key: 'stress',
      label: 'Estresse',
    },
    {
      key: 'mudanca_temperatura',
      label: 'Mudança de Temperatura',
    },
    {
      key: 'infeccoes',
      label: 'Infecções',
    },
    {
      key: 'calor',
      label: 'Calor',
    },
    {
      key: 'frio',
      label: 'Frio',
    },
    {
      key: 'vacinas',
      label: 'Vacinas',
    },
  ],
}

export const FLARES_OPTIONS_SUMMARIZED = {
  events: [],
  triggers: [
    {
      key: 'nao_identificado',
      label: 'Não Identificado',
    },
    {
      key: 'stress',
      label: 'Estresse',
    },
    {
      key: 'mudanca_temperatura',
      label: 'Mudança de Temperatura',
    },
    {
      key: 'infeccoes',
      label: 'Infecções',
    },
    {
      key: 'calor',
      label: 'Calor',
    },
    {
      key: 'frio',
      label: 'Frio',
    },
    {
      key: 'vacinas',
      label: 'Vacinas',
    },
  ],
}
